import { render, staticRenderFns } from "./TableForPortfolio.vue?vue&type=template&id=90c0435c"
import script from "./TableForPortfolio.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableForPortfolio.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TableForPortfolio.vue?vue&type=style&index=0&id=90c0435c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TableForPortfolio.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MetricsActionMenu: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/ActionMenu.vue').default,IxButtonAction: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/button/Action.vue').default,IxKpiEdit: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/kpiEdit.vue').default,IxDialogMetricAggregationContent: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/MetricAggregationContent.vue').default,IxDialogMetricAssignment: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/dialog/MetricAssignment.vue').default,IxBtnRecalculateKpiValues: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/btn/RecalculateKpiValues.vue').default,IxDataTableMetricAggregations: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/MetricAggregations.vue').default,IxDataTableMetricAssignments: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/data-table/MetricAssignments.vue').default,MetricsMetricValuesDialog: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/MetricValuesDialog.vue').default})
